<button [disabled]="disabled" type="button" class="{{'inline-flex items-center' + ' ' + optionalClasses}}" [ngClass]="{'cursor-default text-disabled': disabled, 'cursor-pointer': !disabled, 'primary-700': style === 'primary'}">
  <mat-icon *ngIf="iconLeft" [svgIcon]="iconLeft" [color]="style" class="mr-2"></mat-icon>
  <span *ngIf="text" [ngClass]="{'text-disabled': disabled, 'text-danger': style === 'warn'}" class="label mr-1 whitespace-nowrap">{{text}}</span>
  <mat-icon *ngIf="iconRight" [svgIcon]="iconRight" [color]="style"></mat-icon>
</button>
